module.exports = __webpack_public_path__ + "static/media/Robotbanner.daae045b.png";